export default __webpack_public_path__ + "static/media/exam-411-small.882e0aef.png";